// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2168":"ed4aef5f","4108":"91885859","4888":"a75ab32f","5680":"ed4aef5f","6484":"ed4aef5f","6963":"ed4aef5f","8332":"db6ec9b4","9336":"6c81fe7f","9864":"ed4aef5f"}[chunkId] + ".chunk.css";
};